module.exports = "/_next/static/images/6ccc1b0e99ab314ed4554c1a5525c23e-hero-variant-xs.png.webp";